import React, { Component } from "react";

import { Access } from "common";
import { Breadcrumbs, Navigation, Page } from "components";

import Globe from "assets/images/reports/globe.svg";
import PointsProvisioning from "assets/images/reports/points-provisioning.svg";
import RankingPerson from "assets/images/reports/ranking-person.svg";
import RankingTop from "assets/images/reports/ranking-top.svg";
import Ticket from "assets/images/reports/ticket.svg";
import VoucherExpenses from "assets/images/reports/voucher-expenses.svg";
import VoucherPercent from "assets/images/reports/voucher-percent.svg";
import VoucherValue from "assets/images/reports/voucher-value.svg";

class Main extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Relatórios", to: "" },
    ],
    navigation: [
      {
        name: "Relatório Geral",
        to: "/report/generals",
        icon: Globe,
        hidden: !Access.hasPermissions("manage-report-general"),
      },
      {
        name: "Relatório de Pontos",
        to: "/report/points",
        icon: VoucherValue,
        hidden: !Access.hasPermissions("manage-report-points"),
      },
      {
        name: "Relatório de Benefícios",
        to: "/report/benefits",
        icon: VoucherPercent,
        hidden: !Access.hasPermissions("manage-report-benefits"),
      },
      {
        name: "Relatório de Ticket Médio",
        to: "/report/tickets",
        icon: Ticket,
        hidden: !Access.hasPermissions("manage-report-average-tickets"),
      },
      {
        name: "Ranking de Cadastros",
        to: "/report/registers-ranking",
        icon: RankingPerson,
        hidden: !Access.hasPermissions("manage-report-ranking-registers"),
      },
      {
        name: "Ranking de Pontos",
        to: "/report/points-ranking",
        icon: RankingTop,
        hidden: !Access.hasPermissions("manage-report-ranking-points"),
      },
      {
        name: "Relatório de Provisão de Pontos",
        to: "/report/provision-points",
        icon: PointsProvisioning,
        hidden: !Access.hasPermissions("manage-report-provisioned-points"),
      },
      {
        name: "Relatório de Desp. Vouchers",
        to: "/report/voucher-expense",
        icon: VoucherExpenses,
        hidden: !Access.hasPermissions("manage-report-provisioned-vouchers"),
      },
      {
        name: "Web Prêmios",
        to: "/report/webpremios",
        icon: null,
        hidden: !Access.hasPermissions("manage-report-webpremios"),
      },
      {
        name: "Relatório Contábil",
        to: "/report/accountant",
        icon: null,
        hidden: !Access.hasPermissions("manage-report-accountant"),
      },
      {
        name: "Validação Contábil",
        to: "/report/accounting-validation",
        icon: null,
        hidden: !Access.hasPermissions("accounting-validation"),
      },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
